













import Vue from 'vue';
import { getContentArea } from '@/contentful';

interface Data {
  message: string | null;
}

export default Vue.extend({
  name: 'ssoError',
  beforeMount() {
    getContentArea('unauthorized-error').then((message) => {
      if (message) {
        this.message = message.fields.content;
      }
    });
  },
  data(): Data {
    return {
      message: null,
    };
  },
  methods: {},
});
